import usePaymentModalBR from './usePaymentModal.br';
import usePaymentModalCL from './usePaymentModal.cl';
import usePaymentModalCO from './usePaymentModal.co';
import usePaymentModalMX from './usePaymentModal.mx';

const locales = {
  BR: usePaymentModalBR,
  CL: usePaymentModalCL,
  CO: usePaymentModalCO,
  MX: usePaymentModalMX,
};

export default locales;
